import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root',
})
export class PoliciesService {
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async getPolicy() {

    return this.httpClient
      .post(this.Customeroutes.getpolicies(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async policyData(uuid: any) {
    const data = {
      uuid: uuid
    }

    return this.httpClient
      .post(this.Customeroutes.getpolicy(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          return data;
        }
      });
  }


  async getPolicyFilter(date: any, month: any, year: any) {
    //alert('inpolicy');
    const formData = {
      'date': date || '',
      'month': month || '',
      'year': year || '',
    };
    return this.httpClient
      .post(this.Customeroutes.getPoliciesFilter(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }
}
